import React, { useState, useEffect } from "react";
import { Images } from "../../../assets/images";
import { Helmet } from "react-helmet";
import { Hero } from "../Resources/Webinar";
import { HyperLink } from "../../common/FormInputs";
import { CSSTransition } from "react-transition-group";
import {
  Container,
  List,
  ContentWrapper,
  MainSection,
  ContentBox,
  ImagePlaceholder,
  Description,
  Section,
  SectionHeader,
  SectionContent,
  ContentTitle,
  HeroContent,
  HeroTitle,
  HeroOverlay,
  ArrowIcon,
  NumberList,
} from "./Styles";

/* eslint-disable jsx-a11y/anchor-is-valid */

const WorldOfMediation = () => {
  const [expanded, setExpanded] = useState(null);

  const toggle = (key) => setExpanded(expanded === key ? null : key);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      key: "objectives",
      title: "Course Objectives",
      content: (
        <p>
          The programme focusses on{" "}
          <HyperLink
            onClick={() =>
              window.open(
                `https://user.iamch.org.in/training/corporate-short-programme`
              )
            }
          >
            ADR{" "}
          </HyperLink>
          in general and mediation in specific. It is a quick go-to tool for
          people looking to learn about how mediation works.
        </p>
      ),
    },
    {
      key: "learning",
      title: "Learning Objectives",
      content: (
        <NumberList>
          <li>Introduction to ADR.</li>
          <li>What is mediation, its objective and its benefits?</li>
          <li>Mediation vs Litigation - comparative analysis.</li>
          <li>Nature of disputes & personalities in a dispute.</li>
          <li>Structured Process of Mediation.</li>
          <li>Principles of Negotiation.</li>
          <li>Structured Process of Mediation</li>
          <li>Mediation settlement agreement.</li>
          <li>IAMC - Introduction to the platform.</li>
        </NumberList>
      ),
    },
    {
      key: "duration",
      title: "Duration",
      content: (
        <List>
          <li>10 hours of video lectures.</li>
          <li>Self learning assignments.</li>
        </List>
      ),
    },
    {
      key: "link",
      title: "Link",
      content: (
        <>
          <p>
            To access and purchase the World Of Mediation course, please click
            the link below.
          </p>
          <a
            style={{
              color: "blue",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open(
                "https://www.udemy.com/course/world-of-mediation/?referralCode=AC543A687FAF0488CE66"
              )
            }
          >
            https://www.udemy.com/course/world-of-mediation/?referralCode=AC543A687FAF0488CE66
          </a>
        </>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <title>Mediation Online Training Programme - IAMC</title>
        <meta
          name="description"
          content="Online Mediation Training Program focuses on ADR in general, and mediation in specific. It is a quick go-to option for people looking to learn about how mediation works."
        />
        <meta
          name="keywords"
          content="Online Mediation Training Program, Arbitration Mediation and Conciliation, Online Training Course for Mediation, ADR Training Course for Mediation, Online Arbitration, Resolve Disputes Online, Negotiation Mediation and Arbitration, IAMC"
        />
      </Helmet>

      <Container>
        <Hero bgImage={Images.worldMediation}>
          <HeroOverlay>
            <HeroContent>
              <HeroTitle>World of Mediation</HeroTitle>
            </HeroContent>
          </HeroOverlay>
        </Hero>

        <MainSection>
          <ContentWrapper>
            <ImagePlaceholder bgImage={Images.Mediation} />

            <ContentBox>
              <ContentTitle>World of Mediation</ContentTitle>
              <Description>
                We have created a completely online training course just for
                you. The link to the training is placed below for you to join
                and partake of the same.
              </Description>

              {sections.map(({ key, title, content }) => (
                <Section key={key}>
                  <SectionHeader onClick={() => toggle(key)}>
                    <span>{title}</span>
                    <ArrowIcon expanded={expanded === key}>
                      {expanded === key ? "▲" : "▼"}
                    </ArrowIcon>
                  </SectionHeader>

                  <CSSTransition
                    in={expanded === key}
                    timeout={250}
                    classNames="expand"
                    unmountOnExit
                  >
                    <SectionContent>{content}</SectionContent>
                  </CSSTransition>
                </Section>
              ))}
            </ContentBox>
          </ContentWrapper>
        </MainSection>
      </Container>
    </>
  );
};

export default WorldOfMediation;
